import {
  AccessMethod as AccessMethodProto,
  AccessStatus as AccessStatusProto,
  type PlatformConnection as PlatformConnectionProto,
} from '@taxfyle/api-internal/internal/bookkeeping_pb'
import type { BookkeepingPlatformConnectionProps } from '@/features/jobs/bookkeeping/platform-connections/BookkeepingPlatformConnection'
import type {
  BookkeepingAccessMethod,
  BookkeepingManagerAction,
} from './BookkeepingPendingAction'
import type { BookkeepingPendingActionSortField } from './BookkeepingManagerStore'
import { match } from '@/utils/pattern-match-util'

export function mapAccessStatusProtoToBookkeepingManagerAction(
  accessStatus: AccessStatusProto,
): BookkeepingManagerAction {
  return match<AccessStatusProto, BookkeepingManagerAction>(accessStatus, {
    [AccessStatusProto.MANAGED_ACCESS_ADMIN_CONFIRMATION_REQUESTED]:
      'ConfirmAccess',
    [AccessStatusProto.ACCESS_STATUS_UNSPECIFIED]: 'Unspecified',
    [AccessStatusProto.NOT_REQUESTED]: 'Unspecified',
    [AccessStatusProto.MANAGED_ACCESS_CLIENT_CONNECTION_REQUESTED]:
      'Unspecified',
    [AccessStatusProto.MANAGED_ACCESS_CLIENT_CONFIRMATION_REQUESTED]:
      'Unspecified',
    [AccessStatusProto.MANAGED_ACCESS_CONFIRMED]: 'Unspecified',
    [AccessStatusProto.UNMANAGED_ACCESS_CLIENT_CONFIRMATION_REQUESTED]:
      'Unspecified',
    [AccessStatusProto.UNMANAGED_ACCESS_PROVIDER_CONFIRMATION_REQUESTED]:
      'Unspecified',
    [AccessStatusProto.UNMANAGED_ACCESS_CONFIRMED]: 'Unspecified',
  })
}

export function mapAccessMethodProtoToBookkeepingAccessMethod(
  accessMethod: AccessMethodProto,
): BookkeepingAccessMethod {
  return match<AccessMethodProto, BookkeepingAccessMethod>(accessMethod, {
    [AccessMethodProto.MANAGED]: 'Managed',
    [AccessMethodProto.UNMANAGED]: 'Unmanaged',
    [AccessMethodProto.ACCESS_METHOD_UNSPECIFIED]: 'Unspecified',
  })
}

export function mapPlatformConnectionProtoToProps(
  proto: PlatformConnectionProto,
): BookkeepingPlatformConnectionProps | undefined {
  const quickBooks = proto.getQuickBooks()
  if (quickBooks) {
    return {
      type: 'QuickBooks',
      quickBooks: {
        connectionId: quickBooks.getConnectionId(),
        realmId: quickBooks.getRealmId(),
        companyName: quickBooks.getCompanyName(),
      },
    }
  }

  const xero = proto.getXero()
  if (xero) {
    return {
      type: 'Xero',
      xero: {
        connectionId: xero.getConnectionId(),
        tenantId: xero.getTenantId(),
        tenantName: xero.getTenantName(),
      },
    }
  }

  const other = proto.getOther()
  if (other) {
    return { type: 'Other', other: { info: other.getInfo() } }
  }

  return undefined
}

export function mapBookkeepingPendingActionSortFieldToOrderBy(
  field: BookkeepingPendingActionSortField,
) {
  switch (field) {
    case 'DatePendingSince':
      return 'date_pending_since'
    case 'Id':
      return 'id'
  }
}
